/*
 * The bar above a list while messages are selected for copying: how many, what the copy will be
 * (markdown — the same text *Copy as markdown* writes for one message), and the way out. The
 * timeline and the thread pane draw the same bar over their own selection, which is why it takes
 * a count and two callbacks and knows nothing about where the selection lives.
 */

import { Button } from "../../../ui/index.ts"
import { t } from "../i18n/t.ts"

export function SelectionBar({
	count,
	onCopy,
	onClear,
}: {
	count: number
	onCopy: () => void
	onClear: () => void
}) {
	return (
		<div className="tb-selection" role="group" aria-label={t("chat.message.selected", { count })}>
			<Button
				variant="primary"
				label={t("chat.message.copySelection", { count })}
				onClick={onCopy}
			/>
			<span className="tb-selection__hint">{t("chat.message.copySelectionHint")}</span>
			<Button label={t("chat.message.clearSelection")} onClick={onClear} />
		</div>
	)
}
